/* global downloadMetadata */
const html = require('choo/html');
const assets = require('../../common/assets');
const archiveTile = require('./archiveTile');
const modal = require('./modal');
const noStreams = require('./noStreams');
const notFound = require('./notFound');
const downloadPassword = require('./downloadPassword');
const downloadCompleted = require('./downloadCompleted');
const BIG_SIZE = 1024 * 1024 * 256;

function createFileInfo(state) {
  return {
    id: state.params.id,
    secretKey: state.params.key,
    nonce: downloadMetadata.nonce,
    requiresPassword: downloadMetadata.pwd
  };
}

function downloading(state, emit) {
  return html`
    <div
      class="flex flex-col w-full items-center py-6 md:py-8 md:justify-center md:-mt-4"
    >
      <h1 class="text-3xl font-bold mb-4">
        ${state.translate('downloadingTitle')}
      </h1>
      ${archiveTile.downloading(state, emit)}
    </div>
  `;
}

function preview(state, emit) {
  if (state.fileInfo.flagged) {
    return html`
      <div
        class="flex flex-col w-full max-w-md mx-auto items-center justify-center py-10"
      >
        <h1 class="text-xl font-bold">${state.translate('downloadFlagged')}</h1>
      </div>
    `;
  }
  if (!state.capabilities.streamDownload && state.fileInfo.size > BIG_SIZE) {
    return noStreams(state, emit);
  }
  return html`
    <div class="w-full md:flex md:flex-row md:items-stretch md:gap-8">
      <div
        class="px-2 w-full md:px-0 flex-half md:flex md:flex-col mt-8 md:mt-12 md:pr-0 pb-4"
      >
        <h1 class="text-3xl font-bold mb-4 text-center md:text-left">
          ${state.translate('downloadTitle')}
        </h1>
        <p
          class="text-grey-80 leading-normal dark:text-grey-40 mb-4 text-center md:text-left"
        >
          ${state.translate('downloadDescription')}
        </p>
        <p
          class="text-grey-80 leading-normal dark:text-grey-40 font-semibold text-center md:mb-8 md:text-left"
        >
          ${state.translate('downloadConfirmDescription')}
        </p>
        <img
          class="hidden md:block dl-bg w-full"
          src="${assets.get('intro.svg')}"
        />
      </div>
      <div
        class="w-full flex-half md:flex md:flex-col md:min-h-0 pb-4"
      >
        ${archiveTile.preview(state, emit)}
        <a href="/report" class="link-blue mt-4 text-center block flex-shrink-0 mb-4"
          >${state.translate('reportFile', {
            count: state.fileInfo.manifest.files.length
          })}</a
        >
      </div>
    </div>
  `;
}

module.exports = function(state, emit) {
  let content = '';
  if (!state.fileInfo) {
    state.fileInfo = createFileInfo(state);
    if (downloadMetadata.status === 404) {
      return notFound(state);
    }
    if (!state.fileInfo.nonce) {
      // coming from something like the browser back button
      return location.reload();
    }
  }

  if (state.fileInfo.dead) {
    return notFound(state);
  }

  if (!state.transfer && !state.fileInfo.requiresPassword) {
    emit('getMetadata');
  }

  if (state.transfer) {
    switch (state.transfer.state) {
      case 'downloading':
      case 'decrypting':
        content = downloading(state, emit);
        break;
      case 'complete':
        content = downloadCompleted(state);
        break;
      default:
        content = preview(state, emit);
    }
  } else if (state.fileInfo.requiresPassword && !state.fileInfo.password) {
    content = downloadPassword(state, emit);
  }
  return html`
    <main class="main">
      ${state.modal && modal(state, emit)}
      <section
        class="relative w-full p-6 md:p-8 md:rounded-xl md:shadow-big bg-white dark:bg-grey-90"
      >
        ${content}
      </section>
    </main>
  `;
};
